import instance from "./request";

// 获取验证码请求
export const GetCaptchaCodeApi = () => instance.get("/api/captchaImage")

// 登录请求
export const LoginApi = (params) => instance.post("/admin/login", params)

// 获取路由请求
export const GetUserRoutersApi = () => instance.get("/admin/getRouters")

// 获取用户信息
export const GetUserInfoApi = () => instance.get("/admin/getInfo")

// 获取通知
export const GetNoticeApi = () => instance.get("/admin/getNotice")
// 发布通知
export const SubmitNoticeApi = (params) => instance.post("/admin/notice/update", params)
// 获取网页版通知
export const GetWebNoticeApi = () => instance.get("/admin/getNotice/web")
// 发布网页版通知
export const SubmitWebNoticeApi = (params) => instance.post("/admin/notice/update/web", params)

// 用户查询
export const GetUsersApi = (params) => instance.get("/admin/getUsers", params)
// 充值
export const UserChargeApi = (params) => instance.post("/admin/user/charge", params)
// 扣减
export const UserCutApi = (params) => instance.post("/admin/user/cut", params)
// 充值
export const UserChangeTermApi = (params) => instance.post("/admin/user/changeTerm", params)
// 注销
export const UserDelApi = (params) => instance.post("/admin/user/del", params)
// 解绑
export const UserUnbindApi = (params) => instance.post("/admin/user/unbind", params)
// 修改密码
export const UserChangePwdApi = (params) => instance.post("/admin/user/changePwd", params)
// 注册
export const UserRegisterPwdApi = (params) => instance.post("/admin/user/register", params)
// 获取公告
export const GetGonggaoApi = () => instance.get("/admin/getGonggao")
// 获取登录公告
export const GetLoginGonggaoApi = (params) => instance.get("/admin/getLoginGonggao")
// 发布登录公告
export const SubmitLoginGonggaoApi = (params) => instance.post("/admin/loginGonggao/update", params)
// 发布公告
export const SubmitGonggaoApi = (params) => instance.post("/admin/gonggao/update", params)
// 导出所有uk
export const GetUksApi = () => instance.get("/admin/getUks")
// 生成卡密
export const CodeCreateApi = (params) => instance.post("/admin/code/create", params)
// 查询卡密
export const GetCodeApi = (params) => instance.get("/admin/getCode", params)
// 代理端注册
export const AgentRegisterPwdApi = (params) => instance.post("/admin/agent/register", params)
// 代理端查询
export const GetAgentsApi = (params) => instance.get("/admin/getAgents", params)
// 代理端充值
export const AgentChargeApi = (params) => instance.post("/admin/agent/charge", params)
// 代理端扣减
export const AgentCutApi = (params) => instance.post("/admin/agent/cut", params)
// 代理端修改密码
export const AgentChangePwdApi = (params) => instance.post("/admin/agent/changePwd", params)
// 代理端注销
export const AgentDelApi = (params) => instance.post("/admin/agent/del", params)
// 代理端修改时间
export const AgentChangeTermApi = (params) => instance.post("/admin/agent/changeTerm", params)
// 刷新用户积分
export const RefreshFenApi = () => instance.get("/admin/refreshFen")
// 获取日志
export const GetLogsApi = (params) => instance.get("/admin/getLogs", params)
// 获取今日日志
export const GetTodayLogsApi = () => instance.get("/admin/getTodayLogs")
// 修改批量查询限制
export const ChangeLimitApi = (params) => instance.post("/admin/changeLimit", params)
// 查询未使用的卡密
export const GetUnusedCodeApi = () => instance.get("/admin/getUnusedCode")
// 查询已使用的卡密
export const GetUsedCodeApi = () => instance.get("/admin/getUsedCode")
// 删除卡密
export const DelCodeApi = (params) => instance.post("/admin/code/del", params)
// 修改登录限制
export const ChangeLoginLimitApi = (params) => instance.post("/admin/changeLoginLimit", params)
